import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { useDevice } from '../../providers/Device';
import { Typography } from '../Typography';
import styles from './PageEmptyState.module.scss';
export function PageEmptyState(_0) {
    let { className, illustration, message, actions, title, testId, maxHeight } = _0, rest = _object_without_properties(_0, [
        "className",
        "illustration",
        "message",
        "actions",
        "title",
        "testId",
        "maxHeight"
    ]);
    const { isMobileDevice } = useDevice();
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: cn(styles.root, className, {
            [styles.mobile]: isMobileDevice,
            [styles.maxHeight]: maxHeight
        }),
        "data-testid": testId
    }, rest), {
        children: [
            illustration,
            /*#__PURE__*/ _jsxs("div", {
                className: styles.textualContent,
                children: [
                    title ? typeof title === 'string' ? /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        weight: "normal",
                        children: title
                    }) : title : null,
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.message,
                        children: typeof message === 'string' ? /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph1",
                            children: message
                        }) : message
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.actionsContainer,
                children: actions
            })
        ]
    }));
}
